import { getFdaDisplayName } from "@capone/common";

export const ROUND_TRIP_TEXT = "Round-trip";
export const ONE_WAY_TEXT = "One-way";
export const FARE_DETAILS = "Fare details";
export const TICKET_OPTION = "Ticket option";
export const getDisruptionProtectionTitle = (
  isFreeFdaEnabled: boolean,
  productVariant?: string
) => getFdaDisplayName({ isFreeFdaEnabled, productVariant });
export const DISRUPTION_PROTECTION_SUBTITLE = "Get help with your trip";
export const CHANGE_DATES = "Change Dates";
export const REVIEW_DETAILS = "Review Itinerary";

export const CONTINUE = "Continue";
